import Spinner from 'react-bootstrap/Spinner';

const StatusSpinner = ()=> {
  return (
    <Spinner animation="border" role="status" style={{color:"#2596be", position:"absolute", top:"50%", left:"50%", zIndex:20000}}>
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  );
};

export default StatusSpinner;